import { render, staticRenderFns } from "./HiwTopSection.vue?vue&type=template&id=2d4314cc&scoped=true&"
var script = {}
import style0 from "./HiwTopSection.vue?vue&type=style&index=0&id=2d4314cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4314cc",
  null
  
)

export default component.exports